var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEuFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
  id: "eu-flag_svg__d"
}, /*#__PURE__*/React.createElement("g", {
  id: "eu-flag_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  id: "eu-flag_svg__a",
  d: "m0-1-.3 1 .5.1z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__a",
  transform: "scale(-1 1)"
})), /*#__PURE__*/React.createElement("g", {
  id: "eu-flag_svg__c"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__b",
  transform: "rotate(72)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__b",
  transform: "rotate(144)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__c",
  transform: "scale(-1 1)"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#039",
  d: "M0 0h640v480H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fc0",
  transform: "translate(320 242.3) scale(23.7037)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__d",
  width: "100%",
  height: "100%",
  y: -6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__d",
  width: "100%",
  height: "100%",
  y: 6
}), /*#__PURE__*/React.createElement("g", {
  id: "eu-flag_svg__e"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__d",
  width: "100%",
  height: "100%",
  x: -6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(-144 -2.3 -2.1)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(144 -2.1 -2.3)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(72 -4.7 -2)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(72 -5 .5)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu-flag_svg__e",
  width: "100%",
  height: "100%",
  transform: "scale(-1 1)"
}))));
export { SvgEuFlag as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYjg2MDM1YzNmYWFjNmQwMTc3MGRlZjVkYTY1MTE3ZTcuc3ZnIjs=";